/**
 * Tarjetas de fuentes de datos del panel del empresario individual, por año tributario.
 * Cada año tiene su propia lista (<año>/tarjetas.js), porque los archivos del SII pueden
 * cambiar de un año a otro. Un año sin lista muestra solo el Formulario 22. La parte del
 * servidor de cada tarjeta está en src/services/declaracionRenta/empresarioIndividual/.
 */
import TARJETAS_2026 from './2026/tarjetas';

const registry = {
  2026: TARJETAS_2026,
};

export const getTarjetasAnio = (anioTributario) => registry[anioTributario] || [];

export const getTarjeta = (anioTributario, id) => getTarjetasAnio(anioTributario).find((t) => t.id === id) || null;
